<ng-container *ngIf="studiesPrices">
    <form #studyParametersForm="ngForm">
        <kiwi-parameters-tab-content-header [saveDisabled]="arePricesReadonly || studyParametersForm.invalid"
                                            (saved)="onSave()"
                                            [titleLabelKey]="titleLabelKey">
        </kiwi-parameters-tab-content-header>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <p [i18nKey]="'parameters.studies.prices.description'"></p>

        <kiwi-spacer [size]="8"></kiwi-spacer>

        <table class="_tableColor">
        <thead>
        <tr class="_titlePartTable">
            <th [i18nKey]="'parameters.studies.prices.study.name'"></th>
            <th [i18nKey]="'common.price'"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let studyName of studiesNames">
            <td>{{'studies.' + studyName | translate}}</td>
            <td>
                <kiwi-currency-input [(ngModel)]="studiesPrices.studiesPrices[studyName]"
                       [min]="studiesPrices.minStudyPrice"
                       [max]="studiesPrices.maxStudyPrice"
                       [name]="studyName + 'Price'"
                       [disabled]="arePricesReadonly">
                </kiwi-currency-input>
            </td>
        </tr>
        </tbody>
    </table>
    </form>
</ng-container>
